import axios from 'axios'
import { useCookies } from 'vue3-cookies'

const { cookies } = useCookies()

const instance = axios.create({
  baseURL: process.env.VUE_APP_LMS_URL,
})

let getAccess = ''
let headers = ''

export async function myapgePWChk(userPW) {
  getAccess = cookies.get('access_token')
  headers = { Authorization: getAccess }
  const data = { password: userPW }

  // console.log(data)
  // console.log(headers)
  try {
    const chkPwRes = await instance.post(
      `/api/v1/member/my/profile/verification`,
      data,
      { headers }
    )
    // console.log(chkPwRes);
    // console.log(chkPwRes.data);
    return chkPwRes.data
  } catch (err) {
    // console.log(err)
    // console.log(err.response)
    return err.response.data
    // if(err.response.data.code == "MB41003400"){
    //     // console.log("비밀번호가 일치하지 않습니다.");
    // }
    // else if(err.response.data.code == "MB41002400"){
    //     // console.log("비밀번호가 입력되지 않았습니다.");
    // }
  }
}

export async function recaptchaVerifiy(token) {
  // getAccess = cookies.get("access_token")
  // headers = { 'Authorization' : getAccess }
  // const recaptchaUrl = "https://www.google.com/recaptcha/api/siteverify"
  // const secretKey = process.env.VUE_APP_SECRET_KEY // 스테이징 비밀키
  // eslint-disable-next-line object-shorthand
  const datas = { token: token }
  try {
    const verifiyRes = await instance.post(`/api/v1/recaptcha`, datas)
    // await instance.post(`/api/v1/recaptcha`, datas)
    // console.log(verifiyRes)
    // const verifiyRes = await instance.post(recaptchaUrl, data)
    // console.log(verifiyRes.data.code)
    return verifiyRes.data.code // EC13000200
  } catch (err) {
    return err.response.data.code
    // console.log(err);
  }
}

// export async function recaptchaVerifiy(token){
//     // getAccess = cookies.get("access_token")
//     // headers = { 'Authorization' : getAccess }
//     const recaptchaUrl = "https://www.google.com/recaptcha/api/siteverify"
//     const secretKey = process.env.VUE_APP_SECRET_KEY // 스테이징 비밀키
//     // const secretKey = "6LeR7pYpAAAAAOQuPQJ7XM0m2YkXjBc9t3EdYifo" // 스테이징 비밀키
//     // const secretKey = "6Le2OOIpAAAAAD3yfuPrX-SzKIvpRFhxbZVUDZCB"  // 운영 비밀키
//     const data = {"secret": secretKey, "response": token}
//     try{
//         // console.log("일단 임시로 찍음");
//         // console.log(recaptchaUrl);
//         // console.log(secretKey);
//         // console.log(data);
//         const verifiyRes = await instance.post(recaptchaUrl, data)
//         // console.log(verifiyRes);
//     } catch(err) {
//         // console.log(err);
//     }
// }

export async function deleteTokenInWithdrawal() {
  getAccess = cookies.get('access_token')
  headers = { Authorization: getAccess }
  console.log('로그아웃으로 들어옴')
  console.log(headers)
  console.log(getAccess)
  try {
    await instance.post(`/api/v1/member/logout`, null, { headers })
    localStorage.clear()
    cookies.remove('access_token')
    cookies.remove('refresh_token')
    cookies.remove('stayToken')
  } catch (err) {
    localStorage.clear()
    cookies.remove('access_token')
    cookies.remove('refresh_token')
    cookies.remove('stayToken')
  }
}

export async function deleteUser(checkCode, enterReason) {
  // eslint-disable-next-line prefer-const
  getAccess = cookies.get('access_token')
  headers = { Authorization: getAccess }

  const datas = { code: checkCode, reason: enterReason }
  console.log(getAccess)
  console.log(headers)
  console.log(checkCode)
  console.log(enterReason)
  console.log(datas)
  try {
    const deleteUserRst = await instance.delete(`/api/v1/member/my/profile`, {
      // eslint-disable-next-line object-shorthand
      headers: headers,
      data: datas,
    })
    // 성공시 MB42000200 code 떨어짐
    return deleteUserRst.data.code
  } catch (err) {
    console.log(err)
    return err.response.data.code
  }
}
